import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { KeyboardDoubleArrowDown } from "@mui/icons-material";
import { useSelector } from "react-redux";
import * as FirestoreService from "../utils/firestoreQuery";
import "./Results.css";
import Background from "../assets/quiz-results-bg.png";

function Results() {
  const { score } = useSelector((state) => state.score);
  const [pic1, setPic1] = useState();
  const [num, setNumber] = useState();

  useEffect(() => {
    window.scrollTo(0, 0);
    setNumber(score);

    FirestoreService.getQuizVideos().onSnapshot((doc) => {
      setPic1(doc.data().quizPics.pic1);
    });
  }, [num]);

  const handleTools = () => {
    window.location.replace("https://aralplus.ph/quick-learning-tools");
  };

  const handleChoice = () => {
    window.location.replace("https://aralplus.ph/choice-module");
  };

  const handleVids = () => {
    window.location.replace("https://aralplus.ph");
  };

  return (
    <Box className="main-result-card">
      <Box className="bg-container">
        <img src={Background} alt="BG" className="bg-img" />
      </Box>
      <Box className="text-container">
        <p className="header-text" style={{ marginTop: "20rem" }}>
          Congratulations!
        </p>
      </Box>
      <Box className="text-container">
        <p className="header-text-2">
          If you answered YES to all or most of the questions, you have a high
          level of customer empowerment!
        </p>
      </Box>
      <Box className="text-container-2">
        <p className="header-text-2">
          Questions that you left unanswered indicate your areas for improvement
          towards increasing the level of empowerment.
        </p>
      </Box>
      <Box sx={{ textAlign: "center", marginTop: "3rem", opacity: "0.3" }}>
        <h1>Scroll down for more</h1>
        <KeyboardDoubleArrowDown sx={{ fontSize: "2rem", fontWeight: "500" }} />
      </Box>
      <Box className="table-card">
        <Box className="table-text-container">
          <p className="p-text">
            See below the Customer Empowerment Grid, in Filipino, which
            showcases the qualities of an empowered customer from various
            elements: knowledge & skills, attitude & confidence, and behavior &
            experience, in four dimensions: Choice, Voice, Respect, and Control.
          </p>
        </Box>
        <Box className="table-container">
          <Box className="table-image-container">
            <img src={pic1} className="table-img" alt="table" />
          </Box>
        </Box>
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        <Box className="text-container">
          <p className="header-text-2" style={{ width: "600px" }}>
            Check out the following to help you improve your empowerment level
            in the Choice dimension:
          </p>
        </Box>
        <Box className="text-container-2">
          <p className="link-text" onClick={() => handleChoice()}>
            Choice Module
          </p>
        </Box>
        <Box className="text-container-2">
          <p className="link-text" onClick={() => handleVids()}>
            Videos of an Empowered Filipino Customer
          </p>
        </Box>
        <Box className="text-container-2" sx={{ marginBottom: "5rem" }}>
          <p className="link-text" onClick={() => handleTools()}>
            Other Quick Learning Tools
          </p>
        </Box>
      </Box>
    </Box>
  );
}

export default Results;
